import { utcToZonedTime } from 'date-fns-tz';

export const validateDate = (date?: Date, timezone?: string) => {
	if (!date) return 'Date is required.';

	const currentDate = timezone ? utcToZonedTime(new Date(), timezone) : new Date();
	const inputDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const currentDateOnly = new Date(
		new Date(currentDate).getFullYear(),
		new Date(currentDate).getMonth(),
		new Date(currentDate).getDate(),
	);
	const inputDateOnly = new Date(
		new Date(inputDate).getFullYear(),
		new Date(inputDate).getMonth(),
		new Date(inputDate).getDate(),
	);

	if (inputDateOnly > currentDateOnly) {
		return 'Please review your selected dates. Future dates cannot be included.';
	}

	const inputHours = date.getHours();
	const inputMinutes = date.getMinutes();
	const currentHours = new Date(currentDate).getHours();
	const currentMinutes = new Date(currentDate).getMinutes();

	if (inputDateOnly.getTime() === currentDateOnly.getTime()) {
		if (inputHours > currentHours || (inputHours === currentHours && inputMinutes > currentMinutes)) {
			return 'Please review your selected time; future times cannot be included.';
		}
	}

	if (inputMinutes !== 0 && inputMinutes !== 30) {
		return 'Please review your selected time; future times cannot be included.';
	}
};
